import { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as updateConfigurationActions from "../../../actions/updateConfigurationActions";
import * as _ from "lodash";
import { TranslationContext } from "../../../context/TranslationContext";
import { CustomParts } from "../completion/CustomParts";
import { sortLayouts } from "../../../services/utils.service";
import { Modal } from '../../../components/Modal';

class CustomPartsModalComponent extends Component {
  static contextType = TranslationContext;
  state = { sortedLayouts: null, availablesLayouts: null, selectedLayout: this.props.layout, openCustomParts: false, modalVisible: false }


  componentWillMount() {
    let layouts = this.props.layouts.filter(layout => layout.available);
    const sortedLayouts = sortLayouts(layouts);
    layouts = this.baseHeightCustomLayouts(sortedLayouts);
    this.setState({ sortedLayouts: sortedLayouts, availablesLayouts: layouts });
  }

  componentDidUpdate(prevProps) {
    if (this.props.baseHeightCustom && this.props.baseHeight !== prevProps.baseHeight) {
      const layouts = this.baseHeightCustomLayouts();
      this.setState({ availablesLayouts: layouts });
    }
    if (this.props.openpopup && this.props.openpopup !== prevProps.openpopup && !this.props.confirmModal) {
      this.setState({ openCustomParts: this.props.openpopup });
    }
  }

  baseHeightCustomLayouts(layouts = false) {
    const sortedLayouts = layouts ? layouts : this.state.sortedLayouts
    let layoutsResult = sortedLayouts
    if (this.props.baseHeightCustom) {
      const availableLayoutsBaseHeights = this.props.layoutsBaseHeights.filter(l => l.baseHeight === this.props.baseHeight)
        .map(l => l.configuration)
      layoutsResult = sortedLayouts.filter(l => availableLayoutsBaseHeights.includes(l.reference))
    }
    return layoutsResult
  }


  handleOpenCustomPartsPopup = () => {
    if (!this.state.selectedLayout) {
      const layout = this.state.availablesLayouts[0]
      this.setState({ selectedLayout: layout.reference })
    }
    this.setState({ openCustomParts: true });
  };

  handleCustomPartsPopup = () => {
    if (this.props.confirmModal) {
      this.props.onChangeHeadstone(true)
    } else {
      this.setState({ modalVisible: false })
    }
  }
  handleCloseCustomPartsPopup = () => {
    this.setState({ openCustomParts: false });
    this.setState({ modalVisible: false })
    this.props.onCloseConfirmPopup()
  };


  handleRespond = (response) => {
    this.props.onCloseConfirmPopup()
    if (response) {
      this.handleOpenCustomPartsPopup()
    }
  };
  closePopUp = () => {
    this.setState({ modalVisible: false })
    this.handleCloseCustomPartsPopup()
  }

  handleValidate = () => {
    setTimeout(() => {
      this.setState({ modalVisible: true });
    }, 200);
  };

  render() {
    const isFamilyConfig = window?.location?.href?.includes("famille");

    if (isFamilyConfig) {
      return null;
    }

    const t = this.context;
    const { openpopup, confirmModal } = this.props;
    const availablesLayouts = this.state.availablesLayouts

    const selectedLayout = availablesLayouts.find(l => l.reference === this.state.selectedLayout)
    const layoutCustom = { layout: (this.props.layoutCustom || false), baseHeight: (this.props.baseHeightCustom || false) }
    return (
      <>
        <Modal
          isOpen={this.state.modalVisible || (confirmModal && openpopup)}
          onRequestClose={() => this.closePopUp()}
          className='engraving-alert'
        >
          <p>{confirmModal ? t("config3d_headstone_modal_confirmation_title"): t("config3d_custom_pieces_modal_confirmation_title")}</p>
          <div className='p-3' style={{ display: 'flex' }}>
            {confirmModal && <button
              className="custom-secondary-button btn-config-secondary text-dark background-page secondary3-hover text-dark-border SquareButton button-small text-cta"
              onClick={() => this.handleCloseCustomPartsPopup()}
            >
              {t("config3d_custom_pieces_modal_cancel_button")}
            </button>}
            <button
              className="text-cta secondary1 custom-secondary-button button-primary button-small text-cta"
              onClick={() => this.handleCustomPartsPopup()}
            >
              {t("config3d_custom_pieces_modal_confirmation_button")}
            </button>
          </div>
        </Modal>
        {this.state.openCustomParts &&
          //this.state.openCustomParts && this.state.selectedLayout &&
          <CustomParts isOpen={this.state.openCustomParts}
            layout={selectedLayout}
            deformable={layoutCustom}
            availablesLayouts={availablesLayouts}
            toggleSteps={this.props.toggleSteps}
            launchIntro={this.props.launchIntro}
            modalName={this.props.modalName}
            onValidate={this.handleValidate}
            onClose={this.handleCloseCustomPartsPopup}></CustomParts>
        }</>
    );
  }
}

export const CustomPartsModal = connect(
  (state, ownProps) => ({
    layout: _.get(state, "configurator.current.configuration.monument.layout"),
    baseHeight: _.get(state, "configurator.current.configuration.monument.base.height"),
    layouts: state.configurator.current.options.layouts,
    layoutsBaseHeights: state.configurator.current.options.layoutsBaseHeights,
  }),
  dispatch => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch)
  })
)(CustomPartsModalComponent);
